/* global Gx3d */

Gx3d.link(window);

export default Gx3d;
